export default "//cdn.scentbird.com/assets/frontbird-site/images/smoothie_59a9f5.jpg";